type OverrideObjectAttributesInput = {
  overridableObject: Record<string, any>
  overridingObject: Record<string, any>
}

/** **MUTATES** overridable object with any common attribute overriden with same from overridableObject
 * recurses where same attribute is an object or array, but not primative
 * any  attributes in overridable object but not in overriding object are left untouched
 * any common attributes are overriden
 * any non present attributes in overridable object but presnt in overriding object are added
 * Essentially a merge with overridingObject taking precendence
 */
export const overrideObjectAttributes = ({ overridableObject, overridingObject }: OverrideObjectAttributesInput) => {
  try {
    Object.entries(overridingObject).forEach(([k, v]) => {
      if (v instanceof Array) {
        if (overridableObject[k] instanceof Array) {
          if (!overridableObject[k] || !(overridableObject[k] instanceof Array)) {
            overridableObject[k] = []
          }
          overrideObjectAttributes({ overridableObject: overridableObject[k], overridingObject: v })
        } else {
          // if a.k isn't array make it so
          overridableObject[k] = v
        }
      } else if (typeof v === 'object') {
        if (!!v) {
          if (!overridableObject[k]) {
            overridableObject[k] = {}
          }
          overrideObjectAttributes({ overridableObject: overridableObject[k], overridingObject: v })
        } else {
          // nulls are overriden
          overridableObject[k] = v
        }
      } else {
        overridableObject[k] = v
      }
    })
  } catch (e: any) {
    console.log({ overridableObject, overridingObject })
    throw new Error(`Cant override: ${e.message} `)
  }
  return overridableObject
}
